import React from 'react';
import './GridList.scss';
import GridItem from '../GridItem';

const GridList = ({ data, length = 150 }) => {
  const gridEle = (list) => {
    return list.map((v, k) => {
      return (
        <div className="grid__wrapper" key={k}>
          <GridItem content={v} length={length} />
        </div>
      );
    });
  };

  return <div className="grids">{gridEle(data)}</div>;
};

export default GridList;
